export interface TechItem {
  name: string;
  category: 'native' | 'backend' | 'ai' | 'data' | 'viz';
}

export const techStack: TechItem[] = [
  { name: 'SwiftUI', category: 'native' },
  { name: 'Swift', category: 'native' },
  { name: 'Mac', category: 'native' },
  { name: 'Windows 10+', category: 'native' },
  { name: 'Python', category: 'backend' },
  { name: 'FastAPI', category: 'backend' },
  { name: 'SQLAlchemy', category: 'backend' },
  { name: 'Pydantic', category: 'backend' },
  { name: 'Uvicorn', category: 'backend' },
  { name: 'Anthropic Claude', category: 'ai' },
  { name: 'OpenAI GPT', category: 'ai' },
  { name: 'DeepSeek', category: 'ai' },
  { name: 'LangChain', category: 'ai' },
  { name: 'LM Studio', category: 'ai' },
  { name: 'Ollama', category: 'ai' },
  { name: 'PostgreSQL', category: 'data' },
  { name: 'MySQL', category: 'data' },
  { name: 'SQL Server', category: 'data' },
  { name: 'Snowflake', category: 'data' },
  { name: 'Databricks', category: 'data' },
  { name: 'BigQuery', category: 'data' },
  { name: 'SQLite', category: 'data' },
  { name: 'Highcharts', category: 'viz' },
  { name: 'Pandas', category: 'viz' },
  { name: 'PyArrow', category: 'viz' },
];

export const categoryLabels: Record<string, string> = {
  native: 'Native App',
  backend: 'Backend',
  ai: 'AI Providers',
  data: 'Databases',
  viz: 'Visualization & Data',
};
